function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Context as ColumnSorting } from "./columnSorting/context";
import { Context as RowSelection } from "./rowSelection/context";
import { Context as SettingsContext } from "./settings/context";
import ColGroup from "./ColGroup";
const StyledTable = styled.table.withConfig({
  componentId: "sc-1i12zlh-0"
})(["border-collapse:collapse;border-spacing:0px;"]);

const Table = ({
  spacing = "normal",
  striped = false,
  horizontalRuled = !striped,
  verticalRuled = false,
  columnSorting = {},
  rowSelection: {
    findSelectionRows = () => {},
    ...rowSelection
  } = {},
  stickyHeader = false,
  children,
  ...props
}) => {
  // Some setup for "row selection" feature
  findSelectionRows(children);
  return /*#__PURE__*/React.createElement(StyledTable, _extends({}, props, {
    role: "grid"
  }), /*#__PURE__*/React.createElement(SettingsContext.Provider, {
    value: {
      spacing,
      horizontalRuled,
      verticalRuled,
      striped,
      stickyHeader
    }
  }, /*#__PURE__*/React.createElement(RowSelection.Provider, {
    value: rowSelection
  }, /*#__PURE__*/React.createElement(ColumnSorting.Provider, {
    value: columnSorting
  }, rowSelection.setValue && /*#__PURE__*/React.createElement(ColGroup, {
    "data-row-selection": true
  }), children))));
};

export { StyledTable };
export default Table;
Table.propTypes = {
  /** The overall spacing. */
  spacing: PropTypes.oneOf(["normal", "condensed"]),

  /** Whether to apply striping to `<tbody>` rows. */
  striped: PropTypes.bool,

  /** Whether to apply horizontal rules (borders). If `striped` is `true`, these default to `false`, otherwise they default to `true`. */
  horizontalRuled: PropTypes.bool,

  /** Whether to apply vertical rules (borders). These will be automatically applied if column grouping (a `<ColGroup />`) is present. */
  verticalRuled: PropTypes.bool,

  /** An object representing the "column sorting" context generated by the `useColumnSorting` custom hook. See Details section for more information. */
  columnSorting: PropTypes.object,

  /** An object representing the "row selection" context generated by the `useRowSelection` custom hook. See Details section for more information. */
  rowSelection: PropTypes.object,

  /** Whether to make the last header row sticky. */
  stickyHeader: PropTypes.bool,

  /** The table contents. */
  children: PropTypes.node
};